var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from 'react';
import { inject, observer } from 'mobx-react';

import { ValueViewer } from 'sdc-react-viewers';
import { fieldValue } from 'sdc-data-models';

var ViewingControl = inject('editingStore')(observer(function (_ref) {
  var editingStore = _ref.editingStore,
      ignoreIndex = _ref.ignoreIndex,
      editStyle = _ref.editStyle,
      labelStyle = _ref.labelStyle,
      viewStyle = _ref.viewStyle,
      props = _objectWithoutProperties(_ref, ['editingStore', 'ignoreIndex', 'editStyle', 'labelStyle', 'viewStyle']);

  var value = fieldValue(editingStore._sending, props.field.key);
  return React.createElement(ValueViewer, _extends({ value: value, style: viewStyle }, props));
}));
export { ViewingControl };